import { render, staticRenderFns } from "./yaoQing.vue?vue&type=template&id=cf8d6284&scoped=true"
import script from "./yaoQing.vue?vue&type=script&lang=js"
export * from "./yaoQing.vue?vue&type=script&lang=js"
import style0 from "./yaoQing.vue?vue&type=style&index=0&id=cf8d6284&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8d6284",
  null
  
)

export default component.exports